// @ts-nocheck
import * as React from "react";

const Export: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M12.901 1.757a1.133 1.133 0 1 1 .003 2.264l-8.89.001v15.964h15.959v-8.971c-.003-.26.083-.511.241-.714l.085-.097a1.132 1.132 0 0 1 1.938.807v10.107a1.132 1.132 0 0 1-1.132 1.132H2.885a1.132 1.132 0 0 1-1.133-1.027V2.889a1.132 1.132 0 0 1 1.131-1.132h10.018Zm8.217-.007a1.13 1.13 0 0 1 1.132 1.132v4.995a1.134 1.134 0 0 1-1.132 1.148 1.133 1.133 0 0 1-1.132-1.145V5.61l-6.891 6.893a1.132 1.132 0 0 1-.619.324l-.142.015a1.133 1.133 0 0 1-1.148-.87l-.024-.142a1.13 1.13 0 0 1 .338-.928l6.883-6.886h-2.256a1.133 1.133 0 0 1-.714-.236l-.097-.084a1.131 1.131 0 0 1 .806-1.945h4.996Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(Export);
